<template>
  <g>
    <g clip-path="url(#clip0_15_84)">
      <path
        d="M11 22.0002H13V24.0002H11V22.0002ZM7 22.0002H9V24.0002H7V22.0002ZM15 22.0002H17V24.0002H15V22.0002ZM13.41 10.0002L17.03 6.38016C17.22 6.19016 17.32 5.94016 17.32 5.67016C17.32 5.40016 17.21 5.15016 17.03 4.96016L12.7 0.650157C12.41 0.360157 11.98 0.280157 11.61 0.430157C11.24 0.580157 11 0.950157 11 1.35016V7.58016L7.14 3.73016C6.75 3.34016 6.12 3.34016 5.73 3.73016C5.34 4.12016 5.34 4.75016 5.73 5.14016L10.58 10.0002L5.73 14.8502C5.34 15.2402 5.34 15.8702 5.73 16.2602C6.12 16.6502 6.75 16.6502 7.14 16.2602L11 12.4102V18.6402C11 19.0402 11.24 19.4102 11.62 19.5602C11.74 19.6102 11.87 19.6402 12 19.6402C12.26 19.6402 12.52 19.5402 12.71 19.3502L17.03 15.0302C17.22 14.8402 17.32 14.5902 17.32 14.3202C17.32 14.0502 17.21 13.8002 17.03 13.6102L13.41 10.0002ZM13 3.77016L14.91 5.68016L13 7.58016V3.77016ZM13 16.2302V12.4102L14.91 14.3202L13 16.2302Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_84">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000183105)"
        />
      </clipPath>
    </defs>
  </g>
</template>
